import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { setToken, setUserData, toggleNavCollapsed } from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useHistory } from "react-router-dom";
import { Hidden, Switch } from "@mui/material";
import { AiOutlineMenu } from "react-icons/ai";
import { baseUrl, refreshToken } from "@crema/utility/AuthHooks";
import { fetchError, showMessage } from "../../../../../redux/actions";
import { AppState } from "redux/store";
import { isEmpty } from "lodash";

const AppHeader = () => {
  // const { logout } = useAuthMethod();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const history = useHistory();
  const [isLive, setisLive] = useState(false);

  const userData = useSelector<AppState, AppState["userData"]>(({ userData }) => userData).userData;

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();

  function logout() {
    dispatch(setUserData({}));
    dispatch(setToken(""));
  }

  const handleToggleDrawer = () => {
    dispatch(toggleNavCollapsed());
  };

  const token = useSelector<AppState, AppState["token"]>(({ token }) => token).token;

  useEffect(() => {
    setisLive(userData?.portal_mode === "test" ? false : true);
  }, [userData]);

  const changeMode = () => {
    try {
      fetch(`${baseUrl}update-portal-mode/${isLive ? 0 : 1}`, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response?.status) {
            dispatch(setUserData(response?.data));
            dispatch(showMessage(response?.message?.toString()));
          } else {
            dispatch(fetchError(response?.message?.toString()));
            if (
              response?.statusCode === 401 &&
              response?.message === "Unauthorized. Access token is missing or invalid."
            ) {
              refreshToken(dispatch);
            }
          }
        })
        .catch((err) => {
          dispatch(fetchError(err.message?.toString()));
        });
    } catch (error) {
    }
  };

  return (
    <AppBar
      position="relative"
      color="inherit"
      sx={{
        boxShadow: "none",
        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
        backgroundColor: "background.paper",
        width: {
          xs: "100%",
        },
      }}
      className="app-bar"
    >
      <Toolbar
        sx={{
          boxSizing: "border-box",
          minHeight: { xs: 56, sm: 78 },
          paddingLeft: { xs: 5 },
          paddingRight: { xs: 5, md: 7.5, xl: 12.5 },
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Hidden lgUp>
          <Box onClick={handleToggleDrawer}>
            <AiOutlineMenu size={20} />
          </Box>
        </Hidden>
        <Hidden lgDown>
          <Box></Box>
        </Hidden>
        <Box display={"flex"}>
          {/* <Box display="flex" alignItems="center" marginRight={5}>
            <div style={{ fontSize: 16 }}>Test</div>
            <Switch
              checked={isLive}
              onChange={(e) => {
                changeMode();
              }}
            />
            <div style={{ fontSize: 16 }}>Live</div>
          </Box> */}
          <Box onClick={handleClick}>
            <Avatar
              sx={{
                height: 40,
                width: 40,
                cursor: "pointer",
              }}
            />
          </Box>
        </Box>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          sx={{
            py: 4,
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              history.push("/my-account");
            }}
            sx={{
              px: 6,
              py: 1.5,
            }}
          >
            My account
          </MenuItem>
          <MenuItem
            sx={{
              px: 6,
              py: 1.5,
            }}
            onClick={logout}
          >
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
export default AppHeader;
